/* Bits LB - product page behaviour: gallery, variants, quantity, details, related products. */
(function () {
  'use strict';

  if (window.BitsProduct) { window.BitsProduct.scan(); return; }

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  /* Pull the "Specifications:" heading + bullet list out of the description. */
  function extractSpecs(desc) {
    var heads = desc.querySelectorAll('p, h2, h3, h4');
    var head = null;
    for (var i = 0; i < heads.length; i++) {
      if (/^specifications?:?$/i.test(text(heads[i]))) { head = heads[i]; break; }
    }
    if (!head) return null;
    var list = head.nextElementSibling;
    if (!list || !/^(UL|OL)$/.test(list.tagName)) return null;
    var items = [];
    list.querySelectorAll('li').forEach(function (li) {
      var t = text(li);
      if (t) items.push(t);
    });
    if (!items.length) return null;
    head.parentNode.removeChild(head);
    list.parentNode.removeChild(list);
    return items;
  }

  /* Choose up to four spec pairs worth showing at a glance (rule based, generic for any product). */
  var SKIP_KEYS = /^(model|type|series|brand|sku|color|colour|warranty|layout|number of keys|material|package|includes|in the box)/i;
  var PRIORITY = [
    /^(connectivity|connection|interface|ports?|output|power|wattage|total output)\b/i,
    /(multi-?device|devices|simultaneous|compatib)/i,
    /(battery life|runtime|charging time|speed|resolution|display)/i,
    /(range|latency|capacity|length|lifespan|input)/i
  ];
  function pickKeyFacts(pairs) {
    var usable = pairs.filter(function (p) { return !SKIP_KEYS.test(p.k); });
    var picked = [];
    PRIORITY.forEach(function (re) {
      for (var i = 0; i < usable.length; i++) {
        if (picked.indexOf(usable[i]) === -1 && re.test(usable[i].k)) { picked.push(usable[i]); break; }
      }
    });
    for (var j = 0; j < usable.length && picked.length < 4; j++) {
      if (picked.indexOf(usable[j]) === -1) picked.push(usable[j]);
    }
    return picked.slice(0, 4);
  }

  function init(root) {
    if (!root || root.getAttribute('data-bp-ready')) return;
    root.setAttribute('data-bp-ready', '1');

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) {}

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-track]');
    var slides = track ? track.querySelectorAll('.bits-product__slide') : [];
    var thumbs = root.querySelectorAll('[data-thumb]');
    var dots = root.querySelectorAll('[data-dot]');
    var raf = 0;

    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    function goTo(index) {
      if (!track || !slides[index]) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: REDUCE ? 'auto' : 'smooth' });
      setActive(index);
    }

    if (track && slides.length > 1) {
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        });
      }, { passive: true });
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { goTo(parseInt(thumb.getAttribute('data-thumb'), 10)); });
      });
    }

    /* ---------- variants ---------- */
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var stockEl = root.querySelector('[data-stock]');
    var stockText = root.querySelector('[data-stock-text]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var atcPrice = root.querySelector('[data-atc-price]');
    var buyNow = root.querySelector('[data-buynow]');
    var groups = root.querySelectorAll('[data-option-group]');

    function setStock(available) {
      if (!stockEl) return;
      stockEl.classList.toggle('is-out', !available);
      if (stockText) stockText.textContent = available ? 'In stock' : 'Sold out';
    }

    function applyVariant(variant) {
      if (!variant) {
        atc.disabled = true;
        atcLabel.textContent = 'Unavailable';
        atcPrice.hidden = true;
        if (buyNow) buyNow.disabled = true;
        setStock(false);
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = variant.price;
      if (compareEl) {
        compareEl.textContent = variant.compare;
        compareEl.hidden = !variant.compare;
      }
      atcPrice.textContent = '· ' + variant.price;
      atcPrice.hidden = !variant.available;
      atc.disabled = !variant.available;
      atcLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (buyNow) buyNow.disabled = !variant.available;
      setStock(variant.available);

      if (variant.media) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(variant.media)) { goTo(i); break; }
        }
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    groups.forEach(function (group) {
      group.addEventListener('change', function () {
        var values = [];
        groups.forEach(function (g) {
          var checked = g.querySelector('input:checked');
          values.push(checked ? checked.value : null);
          var label = g.querySelector('[data-selected]');
          if (label && checked) label.textContent = checked.value;
        });
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === values[i]; });
        })[0];
        applyVariant(match);
      });
    });

    /* ---------- quantity ---------- */
    var qty = root.querySelector('[data-qty]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });
    }

    /* the add-to-cart bar sticks to the bottom of phone screens: leave room under the footer */
    if (root.querySelector('.bits-product__buy')) document.body.classList.add('bits-has-sticky');

    /* ---------- details: summary, key facts and specifications come from the description ---------- */
    var desc = root.querySelector('[data-desc]');
    var descAcc = root.querySelector('[data-desc-acc]');
    var specsAcc = root.querySelector('[data-specs-acc]');
    var specsList = root.querySelector('[data-specs]');
    var grid = root.querySelector('[data-details]');
    var summary = root.querySelector('[data-summary]');
    var keyBox = root.querySelector('[data-key]');
    var notes = root.querySelector('[data-notes]');
    var titleEl = root.querySelector('.bits-product__title');

    if (desc && specsList) {
      var items = extractSpecs(desc);
      if (items) {
        var warranty = null;
        var pairs = [];
        items.forEach(function (t) {
          var li = document.createElement('li');
          var m = /^([^:]{1,30}):\s*(.+)$/.exec(t);
          if (m) {
            var k = document.createElement('span'); k.className = 'k'; k.textContent = m[1];
            var v = document.createElement('span'); v.className = 'v'; v.textContent = m[2];
            li.appendChild(k); li.appendChild(v);
            pairs.push({ k: m[1], v: m[2] });
          } else {
            li.className = 'plain';
            var only = document.createElement('span'); only.className = 'v'; only.textContent = t;
            li.appendChild(only);
            if (/warranty/i.test(t) && !warranty) warranty = t;
          }
          if (m && /warranty/i.test(m[1]) && !warranty) warranty = m[1] + ': ' + m[2];
          specsList.appendChild(li);
        });
        specsAcc.hidden = false;
        if (grid) grid.classList.add('has-specs');

        /* four key facts as tiles */
        if (keyBox) {
          var chosen = pickKeyFacts(pairs);
          if (chosen.length >= 2) {
            chosen.forEach(function (p) {
              var tile = document.createElement('div');
              var strong = document.createElement('strong'); strong.textContent = p.v;
              var label = document.createElement('span'); label.textContent = p.k;
              tile.appendChild(strong); tile.appendChild(label);
              keyBox.appendChild(tile);
            });
            keyBox.hidden = false;
          }
        }

        if (notes && warranty) {
          var card = document.createElement('div');
          card.className = 'bits-product__note';
          var strongW = document.createElement('strong'); strongW.textContent = warranty;
          var sub = document.createElement('span'); sub.textContent = 'As listed in the specifications';
          card.appendChild(strongW); card.appendChild(sub);
          notes.insertBefore(card, notes.firstChild);
          notes.hidden = false;
        }
      }

      /* the title is already the page heading: drop the copy at the top of the description */
      if (titleEl) {
        var tn = norm(text(titleEl));
        var cands = desc.querySelectorAll('h1, h2, h3, h4, p, strong, b');
        for (var j = 0; j < cands.length && j < 4; j++) {
          var en = norm(text(cands[j]));
          if (!en) continue;
          if (en === tn || (en.length > 12 && (tn.indexOf(en) === 0 || (en.indexOf(tn) !== -1 && en.length <= tn.length + 8)))) {
            var par = cands[j].parentNode;
            par.removeChild(cands[j]);
            if (par !== desc && !text(par)) par.parentNode.removeChild(par);
            break;
          }
        }
      }

      /* the first real paragraph becomes the short summary under the price */
      if (summary) {
        var paras = desc.querySelectorAll('p');
        for (var n = 0; n < paras.length; n++) {
          var pt = text(paras[n]);
          if (pt.length >= 60) {
            summary.textContent = pt;
            summary.hidden = false;
            paras[n].parentNode.removeChild(paras[n]);
            break;
          }
        }
      }
      if (descAcc && !text(desc)) descAcc.hidden = true;
    }

    /* desktop shows description + specifications as columns, so they stay open and are not toggled */
    var core = root.querySelectorAll('.bits-product__acc[data-core]');
    core.forEach(function (acc) {
      acc.querySelector('summary').addEventListener('click', function (e) {
        if (DESKTOP.matches) e.preventDefault();
      });
    });
    function openCore() { if (DESKTOP.matches) core.forEach(function (a) { a.open = true; }); }
    openCore();
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', openCore);

    /* ---------- related products (Shopify recommendations) ---------- */
    var related = root.querySelector('[data-related]');
    var relatedSection = root.querySelector('[data-related-section]');
    if (related && relatedSection && !related.querySelector('.bits-product__card')) relatedSection.hidden = true;
    if (related && related.getAttribute('data-url')) {
      fetch(related.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var holder = document.createElement('div');
          holder.innerHTML = html;
          var fresh = holder.querySelector('[data-related]');
          if (fresh && fresh.querySelector('.bits-product__card')) {
            related.innerHTML = fresh.innerHTML;
            if (relatedSection) relatedSection.hidden = false;
          }
        })
        .catch(function () {});
    }
  }

  function scan() {
    document.querySelectorAll('[data-bits-product]').forEach(init);
  }

  window.BitsProduct = { scan: scan };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();